<template>
  <div>
    <div
      style="text-align: right"
      class="modal-close"
      @click="closeModal">&#10006;</div>
    <div class="modal-user">
      <div 
        class="info text-center my-3 mx-3" 
        style="margin-left: auto; margin-right: auto;">
        <div class="icons">
          <img
            :src="getImageUrl( '/images/Products.png' )"
            width="75px"
            height="75px"
            style=""
            alt="Products">
        </div>
        <div class="field">
          <h3 class="text-center mt-3">{{ item.title }}</h3> 
          <h4 class="text-center text-muted"> {{ item.insight_type }} Insight | {{item.week_duration}} week test</h4>      
          <p>{{ item.descriiption }}</p>
        </div>
        <div class="buttons text-center mx-3">
          <div class="row">
            <div class="w-50 px-2">
              <button
                style="text-align: center;"
                class="btn btn-primary-inverse w-100 mb-3 mt-1"
                @click="closeModal">Skip</button>
            </div>
            <div class="w-50 px-2">  
              <button
              style="text-align: center;"
              class="btn btn-primary w-100 mb-3 mt-1"
              @click="updateInsight">Add insight</button>
            </div>
          </div>  
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import {mapActions} from "vuex";
import moment from "moment";
import profileMixin from "../../../mixins/profileMixin";

export default {
  mixins: [profileMixin],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },

  data:() => ({
    show: false,
    params: {}
  }),

  computed: {
    insightProduct(){
      if(this.item){
        return this.item.products.map((val) => {
          return val.name ? val.name : 'No title';
        }).join(', ')
      }
    },
    insightRegimen(){
      if (this.item){
        return this.item.regimens.map((val) => {
          return val.elements.element_name
        }).join(', ')
      }
    },
    insightCreated(){
      if (this.item){
        return moment(this.item.created_at).format('LLL')
      }
    },
  },

  methods: {
    ...mapActions(['updateInsights']),
    closeModal(){
      this.showModal(false)
    },
    updateInsight(){
      this.params['insightId'] = this.item.id;
      this.params['userId'] = this.item.user_id;
      this.updateInsights(this.params).then(() => {
        Swal.fire('Saved!', '', 'success')
        this.showModal(false)
      })
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/modals/Insight/InfoInsightModal.vue